// import React, { useRef, useState } from "react";
// import profile from "../../../../assets/images/profile.png";

// export const UploadRosterCard = ({ onParsedPlayers }) => {
//   const inputRef = useRef(null);
//   const [uploadStatus, setUploadStatus] = useState("");

//   const parseCSV = (text) => {
//     const lines = text.split('\n').filter(line => line.trim());
//     if (lines.length < 2) return [];

//     const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
//     const players = [];

//     for (let i = 1; i < lines.length; i++) {
//       const values = lines[i].split(',').map(v => v.trim());
//       const player = {
//         photo: profile,
//         name: values[headers.indexOf('name')] || 'Unknown',
//         position: values[headers.indexOf('position')] || '-',
//         previousSchool: values[headers.indexOf('previousschool')] || values[headers.indexOf('previous school')] || '-',
//         newSchool: values[headers.indexOf('newschool')] || values[headers.indexOf('new school')] || '-',
//         gpa: values[headers.indexOf('gpa')] || '-',
//         region: values[headers.indexOf('region')] || '-',
//         update: values[headers.indexOf('update')] || values[headers.indexOf('latest update')] || '-',
//         era: values[headers.indexOf('era')] || '-',
//         velo: values[headers.indexOf('velo')] || values[headers.indexOf('velocity')] || '-',
//         whip: values[headers.indexOf('whip')] || '-',
//         avg: values[headers.indexOf('avg')] || values[headers.indexOf('average')] || '0',
//       };
//       players.push(player);
//     }

//     return players;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;

//     setUploadStatus("Uploading...");

//     const reader = new FileReader();
//     reader.onload = () => {
//       const text = reader.result;
//       const parsedPlayers = parseCSV(text);

//       if (parsedPlayers.length > 0) {
//         onParsedPlayers(parsedPlayers);
//         setUploadStatus(`File uploaded successfully - ${parsedPlayers.length} players`);
//       } else {
//         setUploadStatus("Error parsing CSV file");
//       }
//     };
//     reader.readAsText(file);
//   };

//   return (
//     <div className="rounded-3xl bg-jp-section border border-jp-line p-6 flex flex-col justify-between">
//       <h2 className="text-sm md:text-base font-semibold text-jp-ink mb-4">
//         UPLOAD YOUR TEAM ROSTER
//       </h2>

//       <button
//         type="button"
//         onClick={() => inputRef.current?.click()}
//         className="inline-flex items-center justify-center h-10 px-4 rounded-lg bg-jp-section text-xs md:text-sm text-jp-ink border border-jp-line hover:bg-jp-line transition"
//       >
//         Upload CSV File
//       </button>
//       <input
//         ref={inputRef}
//         type="file"
//         accept=".csv"
//         className="hidden"
//         onChange={handleFileChange}
//       />

//       {uploadStatus && (
//         <div className="mt-3 text-[11px] text-jp-muted">
//           {uploadStatus}
//         </div>
//       )}

//       <div className="mt-4 flex justify-end">
//         <button className="inline-flex items-center h-9 px-4 rounded-full bg-sky-500 text-xs font-semibold text-white hover:bg-sky-400 transition">
//           Analyze with AI
//         </button>
//       </div>
//     </div>
//   );
// };




import React, { useRef, useState } from "react";
import profile from "../../../../assets/images/profile.png";

export const UploadRosterCard = ({ onParsedPlayers }) => {
  const inputRef = useRef(null);
  const [uploadStatus, setUploadStatus] = useState("");

  const parseCSV = (text) => {
    const lines = text.split("\n").filter((line) => line.trim());
    if (lines.length < 2) return [];

    const headers = lines[0]
      .split(",")
      .map((h) => h.trim().toLowerCase());

    const getIndex = (keys) => {
      const arr = Array.isArray(keys) ? keys : [keys];
      for (const key of arr) {
        const idx = headers.indexOf(key.toLowerCase());
        if (idx !== -1) return idx;
      }
      return -1;
    };

    const idxName = getIndex("name");
    const idxPos = getIndex("position");
    const idxPrev = getIndex(["previousschool", "previous school"]);
    const idxNew = getIndex(["newschool", "new school"]);
    const idxGpa = getIndex("gpa");
    const idxRegion = getIndex("region");
    const idxUpdate = getIndex(["latestupdate", "latest update", "update"]);
    const idxEra = getIndex("era");
    const idxVelo = getIndex(["velo", "velocity"]);
    const idxWhip = getIndex("WHIP");
    const idxVideo = getIndex(["videourl", "video url"]);

    const players = [];

    for (let i = 1; i < lines.length; i++) {
      const values = lines[i].split(",").map((v) => v.trim());

      const pick = (idx, fallback = "-") =>
        idx >= 0 && values[idx] !== undefined && values[idx] !== ""
          ? values[idx]
          : fallback;

      const player = {
        photo: profile,
        name: pick(idxName, "Unknown"),
        position: pick(idxPos, "-"),
        previousSchool: pick(idxPrev, "-"),
        newSchool: pick(idxNew, "-"),
        gpa: pick(idxGpa, "-"),
        region: pick(idxRegion, "-"),
        update: pick(idxUpdate, "-"),
        era: pick(idxEra, "-"),
        velo: pick(idxVelo, "-"),
        whip: pick(idxWhip, "-"),
        videoUrl: pick(idxVideo, ""),    // used by Watch videos button
      };

      players.push(player);
    }

    return players;
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadStatus("Uploading...");

    const reader = new FileReader();
    reader.onload = () => {
      const text = reader.result;
      const parsedPlayers = parseCSV(text);

      if (parsedPlayers.length > 0) {
        onParsedPlayers(parsedPlayers);
        setUploadStatus(
          `File uploaded successfully - ${parsedPlayers.length} players`
        );
      } else {
        setUploadStatus("Error parsing CSV file");
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="rounded-2xl sm:rounded-3xl bg-jp-section border border-jp-line p-4 sm:p-5 md:p-6 flex flex-col justify-between h-full">
      <div>
        <h2 className="text-xs sm:text-sm md:text-base font-semibold text-jp-ink mb-3 sm:mb-4">
          UPLOAD YOUR TEAM ROSTER
        </h2>

        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="w-full sm:w-auto inline-flex items-center justify-center h-9 sm:h-10 px-4 sm:px-5 rounded-lg bg-jp-section text-[11px] sm:text-xs md:text-sm text-jp-ink border border-jp-line hover:bg-jp-line transition"
        >
          Upload CSV File
        </button>
        <input
          ref={inputRef}
          type="file"
          accept=".csv"
          className="hidden"
          onChange={handleFileChange}
        />

        {uploadStatus && (
          <div className="mt-2 sm:mt-3 text-[10px] sm:text-[11px] text-jp-muted">
            {uploadStatus}
          </div>
        )}
      </div>

      <div className="mt-3 sm:mt-4 flex justify-end">
        <button className="w-full sm:w-auto inline-flex items-center justify-center h-8 sm:h-9 px-4 sm:px-5 rounded-full bg-sky-500 text-[11px] sm:text-xs font-semibold text-white hover:bg-sky-400 transition">
          Analyze with AI
        </button>
      </div>
    </div>
  );
};
